import React, { useEffect } from "react";
import useCustomerView from "@hooks/useCustomerView";
import CustomerTable from "./CustomerTable";
import { Grid, Pagination } from "semantic-ui-react";
import CustomerEvents from "./CustomerEvents";
import CustomerSessions from "./CustomerSessions";
import CustomerReviews from "./CustomerReviews";
import CustomerDetails from "./CustomerDetails";
import CustomerViewsFilters from "./CustomerViewsFilters";
import useWindowHeight from "@common/components/hooks/useWindowHeight";
import useCustomerReview from "@common/components/hooks/useCustomerReview";

const CustomerTab = () => {
  const {
    pageNumber,
    totalRecords,
    selectedCustomer,
    reviewStatusIds,
    activeViewTab,
    sortableColumns,
    hideViewTab,
    hideDetails,
    pagination,
    isLoading,
    companyId,
    subcompanyId,
    siteId,
    selectedCustomerState,
    getRecords,
    onPageChange,
  } = useCustomerView();
  const { reviewCompleted } = useCustomerReview();

  useEffect(() => {
    if (companyId || subcompanyId || siteId || reviewCompleted) {
      getRecords({ pageNumber, reviewStatusIds });
    }
  }, [
    reviewStatusIds,
    pageNumber,
    sortableColumns,
    reviewCompleted,
    selectedCustomerState,
  ]);

  useEffect(() => {
    // Reset pageNumber when chaging site
    if (companyId || subcompanyId || siteId) {
      getRecords({ pageNumber: 1 });
    }
  }, [companyId, subcompanyId, siteId]);

  const height = useWindowHeight();
  const topTabMaxHeight = height < 880 ? 250 : height < 1200 ? 280 : 300;
  const bottomTabMaxHeight =
    height < 840
      ? "25vh"
      : height < 1000
        ? "35vh"
        : height < 1200
          ? "40vh"
          : "45vh";

  return (
    <div className="h-100">
      <Grid className="h-100">
        <Grid.Column
          className="gs-flex-container-vertical"
          widescreen={!hideDetails && selectedCustomer ? 12 : 16}
          largescreen={!hideDetails && selectedCustomer ? 10 : 16}
          computer={!hideDetails && selectedCustomer ? 10 : 16}
          tablet={!hideDetails && selectedCustomer ? 9 : 16}
          mobile={!hideDetails && selectedCustomer ? 8 : 16}
        >
          <Grid.Row
            className="gs-flex-container-vertical"
            style={
              hideViewTab
                ? selectedCustomer
                  ? { height: "85%" }
                  : { height: "95%" }
                : { height: `${topTabMaxHeight}px` }
            }
          >
            <CustomerTable />
          </Grid.Row>

          {pagination.totalPages > 0 && (
            <Grid.Row className="flex-row-center justify-between">
              <Pagination
                ellipsisItem={null}
                disabled={isLoading}
                onPageChange={onPageChange}
                activePage={pageNumber}
                totalPages={pagination.totalPages}
              />
              <p>
                Showing Items{" "}
                <strong>
                  {pagination.currentItem} to {pagination.lastItem}
                </strong>{" "}
                of <strong>{totalRecords}</strong>
              </p>
            </Grid.Row>
          )}

          {selectedCustomer && (
            <Grid.Row
              style={
                hideViewTab
                  ? {}
                  : { position: "absolute", top: `${topTabMaxHeight + 55}px` }
              }
            >
              <CustomerViewsFilters />
            </Grid.Row>
          )}

          {!hideViewTab && selectedCustomer && (
            <Grid.Row
              style={{
                position: "absolute",
                top: `${topTabMaxHeight + 100}px`,
                maxHeight: bottomTabMaxHeight,
                overflow: "auto",
                width: "100%",
              }}
            >
              {activeViewTab === 1 ? (
                <CustomerEvents />
              ) : activeViewTab === 2 ? (
                <CustomerSessions />
              ) : activeViewTab === 3 ? (
                <CustomerReviews />
              ) : (
                <></>
              )}
            </Grid.Row>
          )}
        </Grid.Column>

        {!hideDetails && selectedCustomer && (
          <Grid.Column
            widescreen={4}
            largeScreen={6}
            computer={6}
            tablet={7}
            mobile={8}
          >
            <CustomerDetails />
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
};

export default CustomerTab;
